<template>
  <div>
    <DxPopup :key="modal.key" v-for="modal of modals" :onInitialized="(e: any) => onPopupReady(modal.key, e.component)"
             v-bind="modal.popupProps as any">
      <component :is="modal.component" @onToolbarChanged="(e: any) => onToolbarChanged(modal.key,e)"
                 @onCloseRequest="(e: any) => onCloseRequest(modal.key,e)" v-bind="modal.props as any"></component>
    </DxPopup>
  </div>
</template>

<script setup lang="ts">
import dxPopup, {type ToolbarItem} from "devextreme/ui/popup";
import {DxPopup} from "devextreme-vue";
import type {Component} from "vue";
import {markRaw, onMounted, ref} from "vue";
import {useModalService} from "@services/modal-service";
import {v4 as uuid4} from "uuid";

type v4uuid = ReturnType<typeof uuid4>;


interface ManagedModal {
  component: Component;
  props?: Record<string, any>;
  popupProps?: Omit<DxPopup, "toolbarItems">
  promiseResolver: (value: any) => void;
  key: v4uuid;
}

interface ActiveModal {
  popup?: dxPopup,
  toolbarItems?: ToolbarItem[],
  key: v4uuid;
}

const modals = ref<ManagedModal[]>([]);
const activeModals = ref<Record<v4uuid, ActiveModal>>({});
const modalService = useModalService();


function getActiveModal(key: v4uuid) {
  if (!activeModals.value[key]) {
    activeModals.value[key] = {
      key: key
    }
  }

  return activeModals.value[key];
}

function onPopupReady(key: v4uuid, popup: dxPopup,) {
  const modal = getActiveModal(key);
  modal.popup = popup;
  modal.popup?.option("toolbarItems", modal.toolbarItems);
  popup.show()
}

function onToolbarChanged(key: v4uuid, toolbarItems: ToolbarItem[]) {
  const modal = getActiveModal(key);
  modal.popup?.option("toolbarItems", toolbarItems);
  modal.toolbarItems = toolbarItems;
}

function onCloseRequest(key: v4uuid, returnValue: any) {
  const modal = getActiveModal(key);
  modal.popup?.hide();
  delete activeModals.value[key];

  const [managedModal] = modals.value.splice(modals.value.findIndex(m => m.key === key), 1);
  managedModal.promiseResolver(returnValue);
}


onMounted(() => {
  modalService.onModalShowRequest(request => {
    modals.value.push({
      component: markRaw(request.component),
      props: request.props,
      popupProps: request.popupProps,
      key: uuid4(),
      promiseResolver: request.promiseResolver
    })
  })
})
</script>